<fgb-mobile-header-bar
  [title]="'photo.scramble.page.title' | translate"
  [showPoints]="true"
  [link]="'/games'"
></fgb-mobile-header-bar>
<div
  class="game-layout-banner"
  [ngClass]="{
    'leaderboard-enabled': isLeaderboardEnabled,
    'pb-lg-0': isLeaderboardEnabled,
  }"
>
  <div class="container" fgbAnimateOnScroll>
    <a class="games-back-btn d-lg-flex d-none text-white" [routerLink]="['/games']">
      <i class="material-icons">chevron_left</i>
      <span>{{ 'games.back.button' | translate }}</span>
    </a>
    <div class="game-banner-img">
      <img src="assets/images/games/PhotoScrambleBanner.jpg" alt="" />
    </div>

    @if (isLeaderboardEnabled) {
      <div class="pt-lg-3 pt-2 pb-3 pb-lg-0">
        <fgb-route-nav>
          <a
            class="nav-item"
            [routerLink]="['/games/photoscramble']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <label>{{ 'photo.scramble.nav.play' | translate }}</label>
          </a>
          <a
            class="nav-item"
            [routerLink]="['/games/photoscramble/leaderboard']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <label>{{ 'photo.scramble.nav.leaderboard' | translate }}</label>
          </a>
        </fgb-route-nav>
      </div>
    }
  </div>
</div>

<div class="mobile-content-wrapper">
  <router-outlet></router-outlet>
</div>
